import Vue from 'vue'
import VueRouter from 'vue-router'
import Trainer from '../views/MathTrainer.vue'
import Stats from '../views/MathStats.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Trainer',
    component: Trainer
  },
  {
    path: '/stats',
    name: 'Stats',
    component: Stats
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
